import React from "react";
import { Button, Row, Col } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../app/stores/store";
import { useCurrentUser } from "../../../app/hooks/useCurrentUser";

const UpdateEmployeeDetails = () => {
  const { modalStore, updateEmployeeStore, employeeStore } = useStore();
  const { role } = useCurrentUser();
  const {
    setUpdateEmployeeDetailsModalVisible,
    setUpdatePersonalInfoModalVisible,
    setUpdatePhysicalInfoModalVisible,
    setUpdateSkillsInfoModalVisible,
    setUpdateEmploymentInfoModalVisible,
    setUpdateSalaryInfoModalVisible,
    setUpdatePhotoModalVisible,
  } = modalStore;
  const { personalInfoFormData } = updateEmployeeStore;
  const { setEmployeeId } = employeeStore;

  const isAccountingOnly = role.includes("Accounting");

  const handleOpenUploadPhoto = () => {
    setEmployeeId(personalInfoFormData.id);
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdatePhotoModalVisible(true);
  };

  const handleOpenPersonalInfoForm = () => {
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdatePersonalInfoModalVisible(true);
  };

  const handleOpenPhysicalInfoForm = () => {
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdatePhysicalInfoModalVisible(true);
  };

  const handleOpenSkillsInfoForm = () => {
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdateSkillsInfoModalVisible(true);
  };

  const handleOpenUpdateEmploymentInfoForm = () => {
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdateEmploymentInfoModalVisible(true);
  };

  const handleOpenUpdateSalaryInfoForm = () => {
    setUpdateEmployeeDetailsModalVisible(false);
    setUpdateSalaryInfoModalVisible(true);
  };

  return (
    <>
      <h2 className="employee-modal-title">Edit Information</h2>

      <Row justify="center" style={{ marginTop: 35 }}>
        {!isAccountingOnly && (
          <>
            <Col>
              <Button
                className="update-details-btn"
                onClick={handleOpenUploadPhoto}
              >
                <h1 style={{ color: "black", fontSize: 30 }}>
                  Update Profile<span style={{ color: "#FF7201" }}>Picture</span>
                </h1>
              </Button>
            </Col>
            <Col style={{ marginTop: 35 }}>
              <Button
                className="update-details-btn"
                onClick={handleOpenPersonalInfoForm}
              >
                <h1 style={{ color: "black", fontSize: 30 }}>
                  Personal <span style={{ color: "#FF7201" }}>Information</span>
                </h1>
              </Button>
            </Col>
            <Col style={{ marginTop: 35 }}>
              <Button
                className="update-details-btn"
                onClick={handleOpenPhysicalInfoForm}
              >
                <h1 style={{ color: "black", fontSize: 30 }}>
                  Physical <span style={{ color: "#FF7201" }}>Information</span>
                </h1>
              </Button>
            </Col>
            <Col style={{ marginTop: 35 }}>
              <Button
                className="update-details-btn"
                onClick={handleOpenSkillsInfoForm}
              >
                <h1 style={{ color: "black", fontSize: 30 }}>
                  Skills <span style={{ color: "#FF7201" }}>Information</span>
                </h1>
              </Button>
            </Col>
            <Col style={{ marginTop: 35 }}>
              <Button
                className="update-details-btn"
                onClick={handleOpenUpdateEmploymentInfoForm}
              >
                <h1 style={{ color: "black", fontSize: 30 }}>
                  Employment <span style={{ color: "#FF7201" }}>Information</span>
                </h1>
              </Button>
            </Col>
          </>
        )}

        <Col style={{ marginTop: 35 }}>
          <Button
            className="update-details-btn"
            onClick={handleOpenUpdateSalaryInfoForm}
          >
            <h1 style={{ color: "black", fontSize: 30 }}>
              Salary <span style={{ color: "#FF7201" }}>Information</span>
            </h1>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default observer(UpdateEmployeeDetails);
